(ns frontend.ui.component.text-input-group.view
  (:require
   [frontend.ui.component.label.view :refer [label]]
   [frontend.ui.component.text-input.view :refer [text-input]]
   [frontend.ui.component.text.view :refer [text]]
   [herb.core :refer [<class]]
   [frontend.ui.component.text-input-group.style :as style]))

(defn text-input-group
  [{:keys [title type value on-change]}]
  [:<>
   [:div
    {:class (<class style/text-input-group)}
    [label
     title]
    [text-input
     {:type      type
      :value     value
      :on-change on-change}]]])
